import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./ModernSearchBar.css";
import { FaSearch, FaMapMarkerAlt } from "react-icons/fa";
import { SearchJob } from "../../../Redux/Slices/JobPost";
import { buildPopularSearchesFromJobs } from "../../../Helper/popularSearches";

const ModernSearchBar = ({ variant = "hero" }) => {
  const navigate = useNavigate();
  const [searchKeyword, setSearchKeyword] = useState("");
  const [searchLocation, setSearchLocation] = useState("");
  const [popularSearches, setPopularSearches] = useState([]);
  const [loadingPopular, setLoadingPopular] = useState(variant === "hero");

  useEffect(() => {
    if (variant !== "hero") return undefined;

    let cancelled = false;

    const loadPopularSearches = async () => {
      setLoadingPopular(true);
      try {
        const response = await SearchJob({ page: 1, limit: 120 });
        if (cancelled) return;
        setPopularSearches(buildPopularSearchesFromJobs(response?.docs || [], 6));
      } catch (error) {
        if (!cancelled) setPopularSearches([]);
      } finally {
        if (!cancelled) setLoadingPopular(false);
      }
    };

    loadPopularSearches();

    return () => {
      cancelled = true;
    };
  }, [variant]);

  const handleSearch = (e) => {
    e.preventDefault();
    const params = new URLSearchParams();
    if (searchKeyword) params.append("keyword", searchKeyword.trim());
    if (searchLocation) params.append("location", searchLocation.trim());

    navigate(`/jobs?${params.toString()}`);
  };

  const handlePopularSearch = (keyword) => {
    const term = keyword.trim();
    setSearchKeyword(term);
    navigate(`/jobs?keyword=${encodeURIComponent(term)}`);
  };

  return (
    <div className={`modern-search-wrapper ${variant}`}>
      <form onSubmit={handleSearch} className="modern-search-form">
        <div className="modern-search-field">
          <div className="modern-search-input-group">
            <FaSearch className="modern-search-icon" />
            <input
              type="text"
              placeholder="Job title, keywords, or company"
              value={searchKeyword}
              onChange={(e) => setSearchKeyword(e.target.value)}
              className="modern-search-input"
            />
          </div>
        </div>

        <div className="modern-search-field">
          <div className="modern-search-input-group">
            <FaMapMarkerAlt className="modern-search-icon" />
            <input
              type="text"
              placeholder="City, state, zip code, or remote"
              value={searchLocation}
              onChange={(e) => setSearchLocation(e.target.value)}
              className="modern-search-input"
            />
          </div>
        </div>

        <button type="submit" className="modern-search-btn">
          <FaSearch /> Find Jobs
        </button>
      </form>

      {variant === "hero" && (loadingPopular || popularSearches.length > 0) && (
        <div className="popular-searches">
          <span className="popular-searches-label">Popular:</span>
          <div className="popular-searches-tags">
            {loadingPopular ? (
              <span className="popular-searches-loading">Loading trends…</span>
            ) : (
              popularSearches.map((search) => (
                <button
                  key={search.keyword}
                  type="button"
                  onClick={() => handlePopularSearch(search.keyword)}
                  className="popular-search-tag"
                >
                  {search.label}
                </button>
              ))
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default ModernSearchBar;
